import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AllPortService } from 'src/app/services/all-port.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-create-all-port-factor',
  templateUrl: './create-all-port-factor.component.html',
  styles: [
  ]
})
export class CreateAllPortFactorComponent implements OnInit {


  public selectedFactor;
  public ranks = {
    lowl:0,
    lowh:0,
    midl:0,
    midh:0,
    highl:0,
    highh:0
  }

  public factors = [];

  public ranksArray=[];

  public allPortFactorForm = this.fb.group({
    lowDesc: ['', Validators.required],
    midDesc: ['', Validators.required],
    highDesc: ['', Validators.required],
    name: [''],
  })

  public allPortRanksForm = this.fb.group({
    teorico:this.fb.group({
      lowl:[''],
      lowh:[''],
      midl:[''],
      midh:[''],
      highl:[''],
      highh:['']
    }),
    economico:this.fb.group({
      lowl:[''],
      lowh:[''],
      midl:[''],
      midh:[''],
      highl:[''],
      highh:['']
    }),
    estetico:this.fb.group({
      lowl:[''],
      lowh:[''],
      midl:[''],
      midh:[''],
      highl:[''],
      highh:['']
    }),
    social:this.fb.group({
      lowl:[''],
      lowh:[''],
      midl:[''],
      midh:[''],
      highl:[''],
      highh:['']
    }),
    politico:this.fb.group({
      lowl:[''],
      lowh:[''],
      midl:[''],
      midh:[''],
      highl:[''],
      highh:['']
    }),
    religioso:this.fb.group({
      lowl:[''],
      lowh:[''],
      midl:[''],
      midh:[''],
      highl:[''],
      highh:['']
    }),
  })

  public id;

  constructor(private fb:FormBuilder, private allPortService: AllPortService) { 
    this.allPortService.getRanks().subscribe(
      resp=>{
        if(resp.length>0) {
          this.id == resp[0]._id;
          this.allPortRanksForm.addControl('_id', new FormControl(resp[0]._id));
          this.allPortRanksForm.addControl('__v', new FormControl(resp[0].__v));
          this.allPortRanksForm.setValue(resp[0]);
          var ranks = resp[0]
          for(let r in ranks){
            if (r!='_id'&&r!='__v'){
              this.ranksArray.push({
                factor:r,
                lowl:ranks[r].lowl,
                lowh:ranks[r].lowh,
                midl:ranks[r].midl,
                midh:ranks[r].midh,
                highl:ranks[r].highl,
                highh:ranks[r].highh,
              })
            }
          }
        }
      },
      err=>console.log(err)
    )

    this.allPortService.getFactors().subscribe(
      resp => {
        this.factors = resp;
        console.log(this.factors);
      }
    )

  }

  ngOnInit(): void {
  }


  changeFactor(event: any){
    setTimeout(() => {
      let factor = this.factors.find(f => f.name == event);
      if (factor){
        this.allPortFactorForm.get('lowDesc').setValue(factor.lowDesc);
        this.allPortFactorForm.get('midDesc').setValue(factor.midDesc);
        this.allPortFactorForm.get('highDesc').setValue(factor.highDesc);
      }
    }, 300)
  }

  reset(){
    this.allPortFactorForm.reset();
  }

  register(){
    if (this.allPortFactorForm.get('name').value!=''){
      this.allPortService.createFactor(this.allPortFactorForm.value).subscribe(
        resp=>{
          this.allPortFactorForm.reset();
          let timerInterval
          Swal.fire({
            title: 'Tipo creado',
            html: '',
            timer: 1000,
            timerProgressBar: true,
            willOpen: () => {
              Swal.showLoading()
            },
            onClose: () => {
              clearInterval(timerInterval)
            }
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              
            }
          })
        },
        err=>console.log(err)
      )

    }
  }

  addRank(){
    this.allPortRanksForm.get(this.selectedFactor).setValue(this.ranks);
    this.allPortService.updateRanks(this.allPortRanksForm.value).subscribe(
      resp=>{
        window.location.reload();
      },
      err=>console.log(err)
    )

  }

}
